import { DashboardWrapper } from "../../container/dashboardWrapper"
import { Container, Heading, MainContent, MainContentWrapper } from "../../styles/account/account";
import { Breadcrumb } from "../../components/breadcrumb/breadcrumb";
import { SubjectBanner } from '../../components/subjects/subject-banner'
import { SubjectList } from "../../components/subjects/subject-list/subject-list";
import { Achievements } from '../../components/achievements'

const Subjects = () => {
    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container>
                    <MainContent>
                        <Heading>
                            Subjects
                        </Heading>
                        <Breadcrumb
                            crumbs={['Subjects']}
                        />
                        <SubjectBanner subject="Mathematics" term="1" numberOfTopics="12" />
                        <SubjectList />
                        <Achievements />
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper>
    )
}

export default Subjects
